import { Testimonial1Block as Testimonial1 } from "./Testimonial1";
import { Testimonial2Block as Testimonial2 } from "./Testimonial2";
import { TestimonialsBlock1 } from "./TestimonialsBlock1";
import { TestimonialsBlock2 } from "./TestimonialsBlock2";
import { TestimonialsBlock3 } from "./TestimonialsBlock3";

export const testimonialBlocks = {
  Testimonial1,
  Testimonial2,
  TestimonialsBlock1,
  TestimonialsBlock3,
  TestimonialsBlock2,
};
